export default __webpack_public_path__ + "locales/pt-BR/FormGallery.json?hash=821e3476ec87ec0a91cd1327e2d81790";